@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  border-bottom: 1px solid var(--border-subtle);
}

/* The whole row is the affordance (Figma draws a caret but no separate control). */
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  width: 100%;
  padding: 10px var(--space-1); // Figma 325:260081 — no matching --space token
  border: none;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: var(--surface-subtle);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.text {
  display: flex;
  flex-direction: column;
  gap: 6px; // Figma dimensions/spacing/1.5 — no matching --space token
  min-width: 0;
}

.name {
  font-size: $font-size-lg;
  font-weight: $font-weight-medium;
  color: var(--text-primary);
  overflow-wrap: break-word;
}

.meta {
  font-size: $font-size-xs;
  color: var(--text-muted);
}

.trailing {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-shrink: 0;
}

.caret {
  color: var(--text-disabled);
}

// Figma 381:309100 — the block is centred in the drawer body, not offset from the top, so it
// fills the free space rather than carrying a fixed top padding.
.empty {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
}

.emptyIcon {
  opacity: 0.3;
}

.emptyText {
  margin: 0;
  font-size: $font-size-md;
  font-weight: $font-weight-medium;
  color: var(--text-primary);
}

// The failure copy occupies the same centred slot as the empty state (plan Design spec).
.notice {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin: 0;
  text-align: center;
  color: var(--text-primary);
}

// Figma 325:260123 — the pill floats bottom-right of the body, clear of the rows.
.action {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: var(--space-4);
}
